/**
 * @generated SignedSource<<f1bdf5e6fe83e1d3cf360238c5d5663a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type QuestionType = "MULTI_CHOICE" | "OPEN_ENDED" | "RATING" | "SINGLE_CHOICE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectsFilter_questionnaire$data = {
  readonly name: string | null | undefined;
  readonly originalId: string;
  readonly questions: ReadonlyArray<{
    readonly isSurveyMeta: boolean | null | undefined;
    readonly originalId: string;
    readonly responseScaleId: string | null | undefined;
    readonly shortForm: string | null | undefined;
    readonly type: QuestionType;
  }>;
  readonly responseScales: ReadonlyArray<{
    readonly originalId: string;
    readonly responseOptions: ReadonlyArray<{
      readonly displayValue: string | null | undefined;
      readonly label: string | null | undefined;
      readonly value: number;
    }>;
  }>;
  readonly " $fragmentType": "ProjectsFilter_questionnaire";
};
export type ProjectsFilter_questionnaire$key = {
  readonly " $data"?: ProjectsFilter_questionnaire$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsFilter_questionnaire">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectsFilter_questionnaire",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Question",
      "kind": "LinkedField",
      "name": "questions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortForm",
          "storageKey": null
        },
        {
          "alias": "responseScaleId",
          "args": null,
          "kind": "ScalarField",
          "name": "originalResponseScaleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSurveyMeta",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponseScale",
      "kind": "LinkedField",
      "name": "responseScales",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ResponseOption",
          "kind": "LinkedField",
          "name": "responseOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayValue",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionnaireInterface",
  "abstractKey": "__isQuestionnaireInterface"
};
})();

(node as any).hash = "bbce70db64bc16212935234287a6e6aa";

export default node;
